<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='内容管理' subPath='文章分类列表'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-button type="primary" @click="showAddDialog">添加分类</el-button>
        </el-col>
      </el-row>
      <el-table :data="categoryList" stripe border :cell-style="{ textAlign: 'center' }">
        <el-table-column prop="name" label="名称" align="center"></el-table-column>
        <el-table-column prop="create_time_str" label="创建时间" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="290px">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <article-category-add :visible="addDialogAvaible"
      :id="currentId"
      @add="add"
      @update="update"
      @closeDialog="closeAddDialog">
    </article-category-add>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import ArticleCategoryAdd from './ArticleCategoryAdd.vue'
export default {
  name: 'article_category_list',
  components: {
    'bread-crumb': BreadCrumb,
    'article-category-add': ArticleCategoryAdd
  },
  created () {
    this.getList()
  },
  data () {
    return {
      currentId: 0,
      categoryList: [],
      addDialogAvaible: false
    }
  },
  methods: {
    async getList () {
      const res = await this.$http.get('/admin/article/category/list')
      if (res.code === 0) {
        this.categoryList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async add (data) {
      const res = await this.$http.post('/admin/article/category/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async update (id, data) {
      const res = await this.$http.post('/admin/article/category/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/article/category/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style>
</style>
